module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-BoldItalic.e52652bb.ttf";